<div class="swd-page">
  <div class="swd-page-header">
    <h1 class="swd-page-title">{{ 'pageNotFound.title' | translate }}</h1>
  </div>

  <div class="swd-page-content">
    <div class="swd-empty-state">
      <p>{{ 'pageNotFound.message' | translate }}</p>
      <a
        class="swd-link"
        routerLink="/">
        {{ 'pageNotFound.returnHome' | translate }}
      </a>
    </div>
  </div>
</div>
